// AUTO-GENERATED SQL Builder (V40 Final) for Invoice
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class InvoiceSql {
  private ast = new SqlAst('Invoice', 'invoice');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingId: SqlField;
  public invoiceNo: SqlField;
  public currentRevision: SqlField;
  public totalAmount: SqlField;
  public depositAmount: SqlField;
  public balanceAmount: SqlField;
  public status: SqlField;
  public issuedDate: SqlField;
  public dueDate: SqlField;
  public booking: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public invoiceRevisionList: SqlNavHybrid;
  public ledgerEntryList: SqlNavHybrid;
  public paymentList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('invoice', 'guid', '', 'id', 'invoice_guid');
    this.bookingId = new SqlField('invoice', 'bookingId', 'booking', 'id', 'invoice_booking');
    this.invoiceNo = new SqlField('invoice', 'invoiceNo', '', 'id', 'invoice_invoiceNo');
    this.currentRevision = new SqlField('invoice', 'currentRevision', '', 'id', 'invoice_currentRevision');
    this.totalAmount = new SqlField('invoice', 'totalAmount', '', 'id', 'invoice_totalAmount');
    this.depositAmount = new SqlField('invoice', 'depositAmount', '', 'id', 'invoice_depositAmount');
    this.balanceAmount = new SqlField('invoice', 'balanceAmount', '', 'id', 'invoice_balanceAmount');
    this.status = new SqlField('invoice', 'status', '', 'id', 'invoice_status');
    this.issuedDate = new SqlField('invoice', 'issuedDate', '', 'id', 'invoice_issuedDate');
    this.dueDate = new SqlField('invoice', 'dueDate', '', 'id', 'invoice_dueDate');
    this.booking = createNavHybrid('invoice', 'invoice_booking', 'Booking');
    this.createdByUser = createNavHybrid('invoice', 'invoice_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('invoice', 'invoice_updatedByUser', 'User');
    this.invoiceRevisionList = createNavHybrid('invoice', 'invoice_invoiceRevisionList', 'InvoiceRevision');
    this.ledgerEntryList = createNavHybrid('invoice', 'invoice_ledgerEntryList', 'LedgerEntry');
    this.paymentList = createNavHybrid('invoice', 'invoice_paymentList', 'Payment');
    this.id = new SqlField('invoice', 'id', '', 'id', 'invoice_id');
    this.isDeleted = new SqlField('invoice', 'isDeleted', '', 'id', 'invoice_isDeleted');
    this.createdBy = new SqlField('invoice', 'createdBy', '', 'id', 'invoice_createdBy');
    this.createdDate = new SqlField('invoice', 'createdDate', '', 'id', 'invoice_createdDate');
    this.updatedBy = new SqlField('invoice', 'updatedBy', '', 'id', 'invoice_updatedBy');
    this.updatedDate = new SqlField('invoice', 'updatedDate', '', 'id', 'invoice_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:InvoiceSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:InvoiceSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:InvoiceSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:InvoiceSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:InvoiceSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:InvoiceSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:InvoiceSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:InvoiceSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:InvoiceSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:InvoiceSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
